/** @format */

import React, { useEffect, useState, useRef, Fragment } from "react";
import TableForm from "./tableForm";
import "../App.css";

import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css";
import logoHead from "./logo/cder_logo.png";
import { set } from "date-fns";
import { Avatar } from "primereact/avatar";
import AvatarEditor from "react-avatar-editor";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";

export const ApprenticeshipReq_UNI_CENTER = () => {
  const [formData, setFormData] = useState({
    intern_req_ref: "",
    intern_req_school_type: "UNI_CENTER",
    intern_name: "",
    intern_birthday: "",
    intern_place_of_birth: "",
    intern_email: "",
    intern_password: "",
    intern_ed_level: "",
    intern_study_field: "",
    intern_study_option: "",
    mentor_name: "",
    intern_grad_school: "",
    intern_docs: "",
    intern_req_date: "",
    intern_req_type: "",
    // ...
  });

  const handleSubmit = async (e) => {
    // e.preventDefault();

    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/apprenticeshipReqSubmit`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      }
    );

    // Check the response status code.
    if (response.status === 200) {
      // Success!
      triggerFileUpload(true);

      document.getElementById("btn-submit-form").disabled = true;
    } else {
      // Error!
      alert("An error occurred while submitting the form data.");
    }
  };

  // file upload ----------------------------------------------

  // const [selectedFile, setSelectedFile] = useState([]);

  // const handleFileChange = (event) => {
  //   setSelectedFile(event.target.files);
  // };

  // const handleFileSubmit = (event) => {
  //   event.preventDefault();

  //   const formDatas = new FormData();
  //   for (let i = 0; i < selectedFile.length; i++) {
  //     formDatas.append("file", selectedFile[i]);
  //   }
  //   console.log(formDatas);
  //   fetch(`${process.env.REACT_APP_BACKEND_URL}/api/upload_files_trainees`, {
  //     method: "POST",
  //     body: formDatas,
  //   })
  //     .then((response) => {
  //       console.log(response.text());
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // };
  // ----------------------------------------------------------------

  const [currentDate, setCurrentDate] = useState(new Date());

  // React.useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentDate(new Date());
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, []);

  // confirmation dialog -------------------------------------------

  // get last request ID -----------------------------------------------

  const [reqCount, setReqCount] = useState(0);
  const fetchReqCount = async (strId) => {
    // Add parameter to URL
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/apprenticeshipLastReqId`;

    const response = await fetch(url, {
      method: "GET",
    });

    const data = await response.json();

    setReqCount(data);
  };
  //----------------------------------------------------------------------

  const [currentReqId, setCurrentReqId] = useState("");

  // request reference autogeneration -------------------------------
  const [reqRef, setReqRef] = useState("");
  function generateRef() {
    const currentYear = new Date().getFullYear();
    const ref = `UDES-DAPR-${String(Number(reqCount) + 1).padStart(
      3,
      "0"
    )}-${currentYear}`;
    setReqRef(ref);
  }
  useEffect(() => {
    generateRef();
    setCurrentReqId((reqCount + 1).toString());
  }, [reqCount]);

  useEffect(() => {
    setFormData({ ...formData, intern_req_ref: reqRef });
  }, [reqRef]);

  //---------------------------------------------------------------==

  useEffect(() => {
    setFormData({ ...formData, intern_req_date: currentDate });
  }, [formData.intern_req_ref]);

  const toast = useRef(null);

  const accept = () => {
    toast.current.show({
      severity: "info",
      summary: "conifrmé",
      detail: "demande envoyée",
      life: 3000,
    });
  };

  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "Annulée",
      detail: "demande annulée",
      life: 3000,
    });
  };

  const confirm1 = (e) => {
    e.preventDefault();
    confirmDialog({
      message: "Confirmer l'envoie de la demande?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Oui",
      rejectLabel: "Non",
      accept: () => handleSubmit(),
      reject,
    });
  };

  // ------------------------------------------------------------
  // file upload ----------------------------------------------

  const FileItem = ({ name, url, onRemoveClick }) => {
    return (
      // Renders a file item in the file list
      <li style={{ listStyleType: "none" }} className="fileItem-list">
        <div className="fileItem-name-clsbtn-container">
          <span className="fileItem-title">{name}</span>
          <button
            className="fileItem-close-btn"
            href="#"
            onClick={onRemoveClick}
          >
            X
          </button>
        </div>
        {name.endsWith(".jpeg") ||
        name.endsWith(".jpg") ||
        name.endsWith(".png") ||
        name.endsWith(".svg") ? (
          // Image file
          <img
            style={{ maxWidth: "300px", maxHeight: "300px" }}
            src={url}
            alt={name}
          />
        ) : (
          // Other file type
          <iframe className="fileItem-iframe" src={url}></iframe>
        )}
      </li>
    );
  };

  const refInput = useRef();
  const refInput2 = useRef();
  const [multipleFiles, setMultipleFiles] = useState([]);

  const handleFileChange = (e) => {
    setMultipleFiles([...multipleFiles, e.target.files[0]]);
    console.log(URL.createObjectURL(e.target.files[0]));
  };

  const handleFileChange2 = (e) => {
    setUploadedProfilePic(URL.createObjectURL(e.target.files[0]));
  };

  const handleFileSubmit = () => {
    const formDatas = new FormData();
    formDatas.append("reqId", currentReqId);
    for (let i = 0; i < multipleFiles.length + 1; i++) {
      formDatas.append("file", multipleFiles[i]);
    }
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/upload_files_trainees`, {
      method: "POST",
      body: formDatas,
    })
      .then((res) => {
        console.log(res.json());
        if (res.status === 200) {
          setSubmitTriggered(false);
          toast.current.show({
            severity: "success",
            summary: "succès",
            detail: "Demande envoyée",
          });
          // setMultipleFiles([]);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  // ----------------------------------------------------------------

  // receive data from the child component (last reqId from the database) ----------

  const [submitTriggered, setSubmitTriggered] = useState(false);

  const triggerFileUpload = (data) => {
    setSubmitTriggered(data);
  };

  // -------------------------------------------------------------------------------
  useEffect(() => {
    fetchReqCount();
    document.getElementById("btn-submit-form").disabled = true;
  }, []);

  useEffect(() => {
    if (
      formData.intern_birthday !== "" &&
      formData.intern_email !== "" &&
      formData.intern_name !== "" &&
      formData.intern_place_of_birth !== "" &&
      formData.intern_grad_school !== "" &&
      formData.intern_ed_level !== "" &&
      formData.intern_study_field !== "" &&
      formData.intern_req_type !== "" &&
      formData.intern_study_option !== ""
    ) {
      document.getElementById("btn-submit-form").disabled = false;
    }
  }, [
    formData.intern_email,
    formData.intern_name,
    formData.intern_birthday,
    formData.intern_place_of_birth,
    formData.intern_grad_school,
    formData.intern_ed_level,
    formData.intern_study_field,
    formData.intern_req_type,
    formData.intern_study_option,
  ]);

  const [internshipType, setInternshipType] = useState("");

  const handleReqTypeChange = (event) => {
    setInternshipType(event.target.value);
  };

  useEffect(() => {
    setFormData({ ...formData, intern_req_type: internshipType });
  }, [internshipType]);

  const displayDate = (date) => {
    date = new Date(date);
    return date.toLocaleDateString("en-GB");
  };

  useEffect(() => {
    if (submitTriggered === true) {
      handleFileSubmit();
    }
    if (submitTriggered === true && profilePic !== null) {
      uploadImageFromBlobUrl(profilePic);
    }
  }, [submitTriggered]);

  const [canvas, setCanvas] = useState(null);
  const [profilePic, setProfilePic] = useState(null);

  const editor = useRef(null);

  const getImageUrl = async (canvas) => {
    const dataUrl = canvas.toDataURL();
    const res = await fetch(dataUrl);
    const blob = await res.blob();

    return window.URL.createObjectURL(blob);
  };

  useEffect(() => {
    if (canvas !== null) {
      const fetchImageUrl = async () => {
        const imageUrl = await getImageUrl(canvas);
        setProfilePic(imageUrl);
      };

      fetchImageUrl(); // Call the async function
    }
  }, [canvas]);

  async function uploadImageFromBlobUrl(blobUrl) {
    try {
      const response = await fetch(blobUrl);
      const blob = await response.blob();
      const file = new File([blob], "profile_pic.jpg", { type: blob.type });

      const profilePicFileSend = new FormData();
      profilePicFileSend.append("reqId", currentReqId);
      profilePicFileSend.append("file", file);

      const uploadResponse = await fetch("/api/profile_pic_upload", {
        method: "POST",
        body: profilePicFileSend,
      });

      // Handle the upload response
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  }

  const [visible, setVisible] = useState(false);
  const [uploadedProfilePic, setUploadedProfilePic] = useState(null);

  return (
    <Fragment>
      <div className=" m-0  text-white main-banner">
        <div className="head-banner-logo">
          <img src={logoHead} alt="logoHead" />
        </div>
        <div className="banner-text-1">
          <p>
            République Algérienne Démocratique et Populaire Ministère de
            l'Enseignement Supérieur et de la Recherche Scientifique Direction
            Générale de la Recherche Scientifique et du Développement
            Technologique
          </p>
        </div>
        <div className="banner-text-2">
          <span>EPST/Centre de Développement des Energies Renouvelables</span>
        </div>
      </div>

      <div className="training-req-container">
        <div className="interns-form-page">
          <div className="input-form-container flex flex-column">
            <h5>formulaire d'information pour demande de stage</h5>

            <div className="flex flex-column pb-4">
              <div className="flex justify-end">
                <div className="flex flex-column">
                  {profilePic ? (
                    <img
                      src={profilePic}
                      alt="profilePic"
                      className="w-32 h-32"
                    />
                  ) : (
                    <img
                      src={require("./images/profile_pic_place_holder.jpg")}
                      alt="placeholder"
                      className="w-32 h-32"
                    />
                  )}
                  <button
                    className=" text-lg bg-gray-200 hover:bg-custom_blue2 text-gray-900 hover:text-white w-32 rounded-b-md "
                    onClick={() => setVisible(true)}
                  >
                    +
                  </button>
                </div>
              </div>

              <Dialog
                header="Sélecteur de photos"
                visible={visible}
                // style={{ width: "50vw" }}
                breakpoints={{ "415px": "75vw", "641px": "100vw" }}
                onHide={() => setVisible(false)}
              >
                <div className="profile-pic-selector flex flex-column justify-center">
                  <div className="flex flex-row justify-center">
                    <AvatarEditor
                      ref={editor}
                      image={uploadedProfilePic}
                      width={250}
                      height={250}
                      border={50}
                      color={[255, 255, 255, 0.6]} // RGBA
                      scale={1.2}
                      rotate={0}
                    />
                  </div>
                  <input
                    type="file"
                    ref={refInput2}
                    style={{ display: "none" }}
                    onChange={handleFileChange2}
                  />
                  <div className="flex justify-content-center gap-3">
                    <button
                      className="bg-gray-200 hover:bg-custom_blue2 text-gray-900 hover:text-white p-3 rounded-md"
                      onClick={() => {
                        if (editor) {
                          setCanvas(editor.current.getImageScaledToCanvas());
                        }
                        setVisible(false);
                      }}
                    >
                      Accepter
                    </button>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        refInput2.current?.click();
                      }}
                      className="bg-gray-200 hover:bg-custom_blue2 text-gray-900 hover:text-white p-3 rounded-md"
                    >
                      Ajouter une photo
                    </button>
                  </div>
                </div>
              </Dialog>
            </div>

            <form onSubmit={confirm1} className="">
              <div className="input-collection">
                <div className="input-group mb-3 ">
                  <label className="input-group-text mb-0" htmlFor="req_no">
                    N°:
                  </label>
                  <div id="req_no" className="form-control mb-0">
                    {reqRef}
                  </div>
                </div>
                <div className="input-group mb-3 ">
                  <label className="input-group-text mb-0" htmlFor="req_date">
                    Date:
                  </label>
                  <div id="dreq_date" className="form-control">
                    {displayDate(currentDate)}
                  </div>
                </div>
                <div className="input-group mb-3 ">
                  <label className="input-group-text mb-0" htmlFor="req_name">
                    Nom et prénom:
                  </label>
                  <input
                    id="req_name"
                    className="form-control mr-2"
                    type="text"
                    value={formData.intern_name}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        intern_name: e.target.value,
                      })
                    }
                  />
                  <p className="">*</p>
                </div>
                <div className="input-group mb-3 ">
                  <label
                    className="input-group-text mb-0"
                    htmlFor="req_birthday"
                  >
                    Date de naissance:
                  </label>
                  <Calendar
                    className=" flex-1 mr-2 border-2 border-gray-300 rounded-md"
                    value={formData.intern_birthday}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        intern_birthday: e.target.value,
                      })
                    }
                  />
                  <p className="">*</p>
                </div>
                <div className="input-group mb-3 ">
                  <label
                    className="input-group-text mb-0"
                    htmlFor="req_place_of_birth"
                  >
                    Lieu de naissance:
                  </label>
                  <input
                    id="req_place_of_birth"
                    className="form-control mr-2"
                    type="text"
                    value={formData.intern_place_of_birth}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        intern_place_of_birth: e.target.value,
                      })
                    }
                  />
                  <p className="">*</p>
                </div>
                <div className="input-group mb-3 ">
                  <label
                    for="email"
                    className="input-group-text mb-0"
                    htmlFor="intern_email"
                  >
                    Email:
                  </label>
                  <input
                    id="intern_email"
                    className="form-control mr-2"
                    type="email"
                    value={formData.intern_email}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        intern_email: e.target.value,
                      })
                    }
                  />
                  <p className="">*</p>
                </div>
                <div className="input-group mb-3 ">
                  <label className="input-group-text mb-0" htmlFor="req_school">
                    Centre Universitaire:
                  </label>
                  <input
                    id="req_school"
                    className="form-control mr-2"
                    type="text"
                    value={formData.intern_grad_school}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        intern_grad_school: e.target.value,
                      })
                    }
                  />
                  <p className="">*</p>
                </div>
                <div className="input-group mb-3 ">
                  <label
                    className="input-group-text mb-0"
                    htmlFor="req_school_level"
                  >
                    Niveau d'instruction:
                  </label>
                  <input
                    id="req_school_level"
                    className="form-control mr-2"
                    type="text"
                    value={formData.intern_ed_level}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        intern_ed_level: e.target.value,
                      })
                    }
                  />
                  <p className="">*</p>
                </div>
                <div className="input-group mb-3 ">
                  <label
                    className="input-group-text mb-0"
                    htmlFor="req_speciality"
                  >
                    Spécialité:
                  </label>
                  <input
                    id="req_speciality"
                    className="form-control mr-2"
                    type="text"
                    value={formData.intern_study_field}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        intern_study_field: e.target.value,
                      })
                    }
                  />
                  <p className="">*</p>
                </div>

                <div className="input-group mb-3 ">
                  <label className="input-group-text mb-0" htmlFor="req_option">
                    Option:
                  </label>
                  <input
                    id="req_option"
                    className="form-control mr-2"
                    type="text"
                    value={formData.intern_study_option}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        intern_study_option: e.target.value,
                      })
                    }
                  />
                  <p className="">*</p>
                </div>

                <div className="radio-input-group">
                  <label className="input-group-text mb-3" htmlFor="ref_field">
                    Type de stage:{" "}
                  </label>

                  <div className="req-radio-input mb-3 ">
                    <label className=" mb-0" htmlFor="ref_field">
                      stage à court terme
                    </label>
                    <input
                      type="radio"
                      name="radioGroup"
                      value="stage à court terme"
                      onChange={handleReqTypeChange}
                    />
                  </div>
                  <div className="req-radio-input mb-3 ">
                    <label className=" mb-0" htmlFor="ref_field">
                      préparation du mémoire de fin d'études
                    </label>
                    <input
                      type="radio"
                      name="radioGroup"
                      value="préparation du mémoire de fin d'études"
                      onChange={handleReqTypeChange}
                    />
                  </div>
                  <div className="req-radio-input mb-3 ">
                    <label className=" mb-0 " htmlFor="ref_field">
                      stage de doctorat
                    </label>
                    <input
                      type="radio"
                      name="radioGroup"
                      value="stage de doctorat"
                      onChange={handleReqTypeChange}
                      className="mr-2"
                    />
                  </div>
                  <p className="">*</p>
                </div>
                <p>Les champs avec le symbole "*" doivent être remplis.</p>
              </div>
              <button
                type="submit"
                id="btn-submit-form"
                icon="pi pi-check"
                className="mr-2 btn btn-primary btn-submit-form"
              >
                Soumettre
              </button>
            </form>
          </div>
          <Toast ref={toast} />

          <div className="p-confirm-dialog	">
            <ConfirmDialog className="p-confirm-dialog" />
          </div>
        </div>

        <div className="navBarControls">
          <div className="file_upload">
            <form
              onSubmit={handleFileSubmit}
              action="/upload_files"
              method="post"
              encType="multipart/form-data"
            >
              <input
                type="file"
                ref={refInput}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />

              <div>
                <h6 className="">Joindre des fichiers avec la demande</h6>

                <ul>
                  {multipleFiles.map((f, index) => (
                    <FileItem
                      key={index}
                      name={f.name}
                      url={URL.createObjectURL(f)}
                      onRemoveClick={() => {
                        setMultipleFiles((prevFiles) =>
                          prevFiles.filter((_, idx) => idx !== index)
                        );
                      }}
                    />
                  ))}
                </ul>
              </div>

              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  refInput.current?.click();
                }}
              >
                +
              </button>

              {/* <button type="submit">Télécharger</button> */}
            </form>
          </div>
        </div>
      </div>

      {/* <footer className="main-footer">
        <div className="">
          <div className="">
            <div className="">
              <h5>About</h5>
              <p>This is the footer with some text.</p>
            </div>
          </div>
        </div>
      </footer> */}
    </Fragment>
  );
};
